export default __webpack_public_path__ + "static/media/Flag of Guam.07e8e01f.gif";